import React from 'react';
import { Accent, SectionHeading } from './SectionHeading';
import { problems } from '../../data/content';
export function ProblemSection() {
  return <section aria-labelledby="problem-heading" className="bg-brand-ivory px-5 py-16 lg:px-8 lg:py-24" data-id="element-171" data-mp="2zl6jhhfpr6am">
      <SectionHeading id="problem-heading" title={<>
            Teaching Makeup Shouldn't Mean <Accent data-id="element-173" data-mp="3div4qqdp0fg7">Reinventing Every Class.</Accent>
          </>} data-id="element-172" data-mp="2ks32pc9y4wky" />

      <ul className="mx-auto mt-12 grid max-w-5xl gap-4 sm:grid-cols-2 lg:grid-cols-3" role="list" data-id="element-174" data-mp="3dgs3tbb051wp">
        {problems.map(({
        icon: Icon,
        text
      }) => <li key={text} className="flex items-start gap-4 rounded-[18px] border border-brand-charcoal/10 bg-white px-5 py-5" data-id="element-175" data-mp="33lgrezn2g6s4">
            <span className="flex h-10 w-10 flex-none items-center justify-center rounded-full bg-brand-lavender text-brand-plum" data-id="element-176" data-mp="1s5i9e69wuaer">
              <Icon className="h-[18px] w-[18px]" strokeWidth={1.75} aria-hidden="true" data-id="element-177" data-mp="1x4v5lhmo8tu0" />
            </span>
            <span className="pt-2 text-[15px] font-medium leading-snug text-brand-charcoal" data-id="element-178" data-mp="1voq4kaeksikg">{text}</span>
          </li>)}
      </ul>

      <div className="mx-auto mt-14 max-w-3xl text-center" data-id="element-179" data-mp="1qqoqk3w0b9fu">
        <p className="font-display text-[1.6rem] font-bold leading-snug text-brand-charcoal sm:text-[1.9rem]" data-id="element-180" data-mp="24pg2bjnecj0t">
          You already know makeup.{' '}
          <Accent data-id="element-181" data-mp="2emknph9f4agk">The challenge is turning that knowledge into a professional teaching system.</Accent>
        </p>
        <p className="mt-5 text-[15px] leading-relaxed text-brand-charcoal/70 sm:text-[16px]" data-id="element-182" data-mp="29npstgy6evg3">
          That is exactly what{' '}
          <strong className="font-semibold text-brand-charcoal" data-id="element-183" data-mp="2ndtdw4lbkj3y">Makeup Instructor Ready</strong> was built to solve.
        </p>
      </div>
    </section>;
}